// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientEmailAddressUpsearchModel {
    static getAttributeTypeMap() {
        return PatientEmailAddressUpsearchModel.attributeTypeMap;
    }
}
PatientEmailAddressUpsearchModel.discriminator = undefined;
PatientEmailAddressUpsearchModel.additionalProperties = false;
PatientEmailAddressUpsearchModel.attributeTypeMap = [
    {
        "name": "emailAddressId",
        "baseName": "emailAddressId",
        "type": "number"
    },
    {
        "name": "emailAddressType",
        "baseName": "emailAddressType",
        "type": "PatientContactInformationPurposeType"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "string"
    },
    {
        "name": "language",
        "baseName": "language",
        "type": "string"
    },
];
//# sourceMappingURL=patientEmailAddressUpsearchModel.js.map